import { I18nComponente } from "@/types/gerais"

export const OCriarEventoPlanejadoi18n: I18nComponente = {
  "pt-BR": {
    lancarAtividadeDe: "lançar atividade de:",
    profissionaisQueSeraoAlocados: "profissionais que serão alocados*",
    dataDeInicio: "data de inicio",
    dataDeFim: "data de fim",
    horarioDeInicio: "horário de inicio",
    duracaoMinutos: "duração (minutos)",
    quantidade: "quantidade",
    projetos: "projetos",
    naoRepete: "não repete",
    ate: "até",
    repetirNosDias: "repetir nos dias:",
    repeteSemanalmente: "repete semanalmente",
    repeticao: "repetição",
    cancelar: "cancelar",
    salvar: "salvar",
    salvarAlteracoes: "salvar alterações",
    eventoDaAtividadePlanejadaLancadaComSucesso: "Evento da atividade planejada lançada com sucesso",
    naoFoiPossivelLancarEventoDaAtividadePlanejada: "Não foi possível lançar  o evento da atividade planejada",
    atividadePlanejadaLancadaComSucesso: "Atividade planejada lançada com sucesso",
    naoFoiPossivelLancarAtividade: "Não foi possível lançar a atividade",
    calendarioDaAtividadeCriadoComSucesso: "Calendário da atividade criado com sucesso",
    naoFoiPossivelCriarCalendarioDaAtividade: "Não foi possível criar o calendário da atividade",
    atributosComValoresInvalidos: "Atributos com valores inválidos",
    naoPreenchaValores: "Para lançar uma atividade planejada com atributos, os valores dos atributos não devem ser preenchidos",

  },
  "es-CO": {
    lancarAtividadeDe: "lanzar actividad de:",
    profissionaisQueSeraoAlocados: "profesionales que serán asignados*",
    dataDeInicio: "fecha de inicio",
    dataDeFim: "fecha de fin",
    horarioDeInicio: "hora de inicio",
    duracaoMinutos: "duración (minutos)",
    quantidade: "cantidad",
    projetos: "proyectos",
    naoRepete: "no se repite",
    ate: "hasta",
    repetirNosDias: "repetir en los días:",
    repeteSemanalmente: "se repite semanalmente",
    repeticao: "repetición",
    cancelar: "cancelar",
    salvar: "guardar",
    salvarAlteracoes: "guardar cambios",
    atividadePlanejadaLancadaComSucesso: "Actividad planeada lanzada con éxito",
    naoFoiPossivelLancarAtividade: "No fue posible lanzar la actividad",
    calendarioDaAtividadeCriadoComSucesso: "Calendario de la actividad creado con éxito",
    naoFoiPossivelCriarCalendarioDaAtividade: "No fue posible añadir el calendario de la actividad",
    atributosComValoresInvalidos: "Atributos con valores inválidos",
    naoPreenchaValores: "Para lanzar una actividad planeada con atributos, los valores de los atributos no deben ser preenchidos",
  },
}
